//Don't remove the commented code.

export const projectDetailsEndPoints = {
    createProject: () => `/project/create/projectDetails`,
    updateProject: (projectId) => `/project/update/projectDetails/${projectId}`,
    // getProjectDetails: () => `/project/get/projectDetails`,
    getProjectDetailsById: (projectId) => `/project/get/projectDetails/${projectId}`,
    getProjectDetailsByOrgId: (orgId) => `/project/get/orgProjectDetails/${orgId}`,
    getProjectSummary: (projectId) => `/project/get/projectSummary/${projectId}`,
    getQuestionsSummary: (projectId) => `/project/get/questionsSummary/${projectId}`,
    getProjectDetailsByUserId: (owner) => `/project/get/userProjectDetails/${owner}`,
    getDeployedProjectDetails: (owner) => `/project/get/deployedProjectDetails/${owner}`,
    getDeployedProjectDetailsForAssesment: (owner) => `/project/get/deployedProjectDetailsForAssessment/${owner}`,
    getDeployedProjectDetailsByOrgArray: () => `/project/get/deployedProjectDetailsByOrgArray`,
    getQrCode: () => `/project/get/signedurl`,
    // getAssesmentFilterData: (projectId) => `/project/get/questionsSummary/${projectId}?filter=true`,
    deleteProject: (projectId) => `/project/delete/${projectId}`,
    getProjectDetailsByOrgArray: () => `/project/get/projectDetailsByOrgArray`,
    checkQrCodeUniqueness: (qrCodeText, projectId) => `/project/check-qr-code-uniqueness?qr_code_text=${encodeURIComponent(qrCodeText)}${projectId ? `&project_id=${projectId}` : ''}`
}

export const userDetailsEndPoints = {
    createUsers: (projectId) => `/user/create/users/${projectId}`,
    getUserDetails: (projectId) => `/user/get/users/projectId/${projectId}`
}


// export const questionDetailsEndPoints = {
//     getQuestions: (questionId) => `/project/get/questionDetails/${questionId}`
// }

export const responseDetailsEndPoints = {
    getResponseDetals: (projectId, questionId) => `/response/get/responseDetails/${projectId}?question_id=${questionId}`,
} 

export const assesmentDetailsEndPoints = {
    createAssessment: () => '/assessment/create/assessmentDetails',
    getAssessmentDetails: (owner) => `/assessment/assessment-details/${owner}`,
    getAssessmentDetailsById: (assessmentId) => `/assessment/assessment-details-by-id/${assessmentId}`,
    getUserResponsesById: (projectId) => `/assessment/non-curated/${projectId}`,
    createCurateResponse: (projectId) => `/assessment/curate/${projectId}`,
    getCuratedResponses: (projectId) => `/assessment/curate/${projectId}`,
    createDiscardedResponse: (projectId) => `/assessment/discard/${projectId}`,
    getDiscardedResponses: (projectId) => `/assessment/discard/${projectId}`,
    uploadFiles: () => `/assessment/uplaod`,
    deleteFiles: () => `/assessment/delete`,
    updateAssessmentDetails: (assessment_id) => `/assessment/update/assessmentDetails/${assessment_id}`,
    getAssessmentDetailsOfAllOrgs: () => `/assessment/assessment-details-by-org-array`,
    getAssessmentDetailsByOrgId: (orgId) => `/assessment/assessment-details-by-org-id/${orgId}`,
    setAssessmentStatusToCurated: (assessmentId) => `/assessment/update-assessment-status/${assessmentId}`,
    prepareDataForReportGeneration: (assessmentId) => `/assessment/prepare-data/${assessmentId}`,
    getDataPreperationStatus: (assessmentId) => `/assessment/prepare-data-status/${assessmentId}`,
    createReportGenerationRequest: (assessmentId) => `/assessment/generate-report/${assessmentId}`,
    getReportGenerationStatus: (assessmentId) => `/assessment/report-generation-status/${assessmentId}`
}

export const queryInsightsEndPoints = {

    postCustomQuestion: () =>'/reports/saveQuestion',
    getCustomQuestions: (assessment_id, user_id) => `/reports/getReport?assessment_id=${assessment_id}&user_id=${user_id}`,
    deleteCustomQuestion: () =>'/reports/delete'

}
export const reportsEndPoints = {
    getSurveyQuestion: () =>'/reports/surveyQuestions',
    getQuestionList: (assessment_id, question_type) =>`/reports/question/list?assessment_id=${assessment_id}&question_type=${question_type}`,
    getQuestionDetails: (question_ids) =>   `/reports/question/details?question_ids=${question_ids}`
}


export const groupEndPoints = {
    getQrCodeList: () => '/groups/qr-list',
    getGroupList: () => '/groups/list',
    generateQrCode: () => '/groups/generate-qr',
    getKnowledgeUrls: () => '/groups/knowledge-urls',
    getKnowledgeUrlGroups: () => '/groups/knowledge-url-groups'
};

export const orgEndPoints = {
    getOrgDetailsById: (orgId) => `/getOrgDetailsById/${orgId}`,
    getSubOrganizations: (parentOrgId) => `/getSubOrganizations/${parentOrgId}`
}